module.exports = __webpack_public_path__ + "img/bim (10).57628eae.png";